import { Clock, NavWebStatsOverview } from '@va/icons';
import { useTranslate } from '@va/localization';
import { contributorRole } from '@va/standalone/shared/selectors';
import {
  IconWithBackground,
  ListCardItemWithIcon,
  Paragraph,
  paragraphSizes,
  SelectableButtonsGroup,
  SelectableButtonsGroupItemProps,
  ToggleActionCard,
} from '@va/ui/design-system';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TrafficAlertBaselineDays } from '../apiClient';
import useTrafficAlertsPreferences from './useTrafficAlertsPreferences';

export const TrafficAlertsToggle = () => {
  const translate = useTranslate();
  const isContributor = useSelector(contributorRole);
  const {
    formValues,
    comparisonPeriodOptions,
    selectedComparisonPeriod,
    handleActivateToggleChange,
    onComparisonPeriodChange,
  } = useTrafficAlertsPreferences();

  const comparisonPeriodButtons = useMemo<SelectableButtonsGroupItemProps[]>(
    () => comparisonPeriodOptions,
    [comparisonPeriodOptions],
  );

  return (
    <ToggleActionCard
      title={translate('form.trafficAlerts.activateToggle')}
      name={'activateTrafficAlerts'}
      className='p-3 pr-5'
      subSectionClass={'!p-3 pl-1.5'}
      value={formValues.trafficAlertActivated}
      handleChange={({ value }) => handleActivateToggleChange(value)}
      disabled={isContributor}
      infoTooltip={isContributor ? translate('tooltips.contributorRole') : undefined}
      icon={() => <IconWithBackground className='bg-white' icon={() => <NavWebStatsOverview />} />}
    >
      <div className={'flex w-full justify-between rounded-12 sm:flex-col bg-white-snow flex-wrap space-y-4u'}>
        <ListCardItemWithIcon
          className='!max-w-full'
          icon={<IconWithBackground className='bg-white' icon={() => <Clock strokeColor='#696969' />} />}
          topText={translate('form.trafficAlerts.frequencyLabel')}
          bottomNode={
            <Paragraph size={paragraphSizes.tiny} colorClassName='text-primary' className='!text-devil-gray'>
              {translate('form.trafficAlerts.frequencySubtitle')}
            </Paragraph>
          }
        />
        <div className='overflow-x-auto scrollbar scrollbar-thumb flex self-center mx-auto'>
          <SelectableButtonsGroup
            buttons={comparisonPeriodButtons}
            selectedValue={selectedComparisonPeriod}
            onChange={(value) => onComparisonPeriodChange(Number(value) as TrafficAlertBaselineDays)}
            className='!bg-white-smoke !justify-center'
            activeButtonColor='secondary'
            inactiveButtonColor='tertiary'
            small
          />
        </div>
      </div>
    </ToggleActionCard>
  );
};
